import { Modal as ModalModule, UI, Utils } from 'common';
import React, { Component } from 'react';
import AccountCommunication from '../utils/AccountCommunication';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;
const { WrappedInputTextWithLabel } = UI;
const { Logger, Validation } = Utils;

export default class ManageRegionModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			regionName: '',
			validation: 0, // 0 = untouched, -1 = failed, 1 = valid
			errorMessage: '',
			clean: true,
		};
	}

	componentDidMount() {
		const {
			data: { modalType, regionName = '' },
		} = this.props;

		if (modalType === 'update') {
			this.setState({
				regionName,
			});
		}
	}

	addRegion = async () => {
		const { regionName } = this.state;
		const {
			data: { onSuccess },
		} = this.props;
		const { showError } = this.context;

		Logger.saveActionData('Add Region Button Clicked');

		const response = await AccountCommunication.addRegion(regionName);

		if (AccountCommunication.isSuccessful(response)) {
			onSuccess();
		} else {
			showError({ response });
		}
	};

	updateRegion = async () => {
		const { regionName } = this.state;
		const {
			data: { onSuccess, regionId },
		} = this.props;
		const { showError } = this.context;

		const data = { regionId, regionName };

		Logger.saveActionData('Update Region Button Clicked');

		const response = await AccountCommunication.updateRegion(data);
		if (AccountCommunication.isSuccessful(response)) {
			onSuccess(true);
		} else {
			showError({ response });
		}
	};

	onSaveButtonClick = () => {
		const { errorMessage, regionName } = this.state;
		const {
			modalId,
			data: { modalType },
		} = this.props;
		const { closeModal, showError } = this.context;

		if (!this.validateInput(regionName)) {
			return showError({
				data: {
					title: 'Incomplete Fields',
					description: Validation.buildValidationErrorDescription({
						regionName: errorMessage,
					}),
					primaryButtonType: ModalButtonActionType.Ok,
					primaryButtonText: 'Close',
					handleType: 'custom',
				},
			});
		}

		if (modalType === 'add') {
			closeModal(modalId, ModalButtonActionType.Ok, this.addRegion(regionName));
		}

		if (modalType === 'update') {
			closeModal(
				modalId,
				ModalButtonActionType.Ok,
				this.updateRegion(regionName)
			);
		}
	};

	onChangeRegionName = ({ target: { value } }) => {
		this.setState({ regionName: value, clean: false });
	};

	onKeyPressEnter = e => {
		const {
			key,
			target: { value },
		} = e;

		if (key === 'Enter' && value !== '') {
			e.preventDefault();

			this.onSaveButtonClick();
		}
	};

	onFieldBlur = () => {
		const { regionName } = this.state;

		this.validateInput(regionName);
	};

	validateInput = regionName => {
		const {
			data: { rowData },
		} = this.props;
		const rowCodes = rowData.map(code => code.Name);

		if (regionName === '') {
			this.setState({
				validation: -1,
				errorMessage: 'This field is required.',
			});
			return false;
		}

		if (rowCodes.includes(regionName)) {
			this.setState({
				validation: -1,
				errorMessage: 'A Region with this name already exists.',
			});
			return false;
		}

		this.setState({
			validation: 1,
			errorMessage: '',
		});
		return true;
	};

	renderText = modalType => {
		if (modalType === 'add') {
			return (
				<p>
					Give your new region a name. Once you create a region, you can assign
					locations to it from the <b>Locations</b> tab.
				</p>
			);
		}

		return (
			<p>
				Tip: to change which locations belong to this region, edit the locations
				from the <b>Locations</b> tab.
			</p>
		);
	};

	render() {
		const {
			modalId,
			data: { modalType },
		} = this.props;
		const { errorMessage, regionName, validation, clean } = this.state;

		const primaryButton = {
			type: ModalButtonActionType.Ok,
			text: 'Save',
			onClick: this.onSaveButtonClick,
			disabled: clean,
			dataqa: 'manage-region-save-button',
		};

		return (
			<Modal
				modalId={modalId}
				className={`account-regions account-${modalType}region-modal`}
				header={modalType === 'add' ? `Add Region` : 'Edit Region Name'}
				primaryButton={primaryButton}
				focusOnShow={false}
				size="small"
			>
				<div className="body">
					{this.renderText(modalType)}
					<WrappedInputTextWithLabel
						label="Region Name:"
						isInputInvalid={validation === -1}
						errorMessage={errorMessage}
						uiElementConfig={{
							type: 'text',
							maxLength: 40,
							name: `${modalType}RegionName`,
							value: regionName,
							onChange: this.onChangeRegionName,
							onKeyPress: this.onKeyPressEnter,
							onBlur: this.onFieldBlur,
							dataqa: `${modalType}regionname`,
							autoFocus: true,
						}}
					/>
				</div>
			</Modal>
		);
	}
}

ManageRegionModal.contextType = ModalContext;
